export const workspaceNameToFileMapping = {
  Inbox: 'inbox-min-version.txt',
  HelpDesk: 'hd-min-version.txt'
};